import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'
import type { ChangeEvent, FormEvent, KeyboardEvent, MouseEvent } from 'react'
import styles from './login.module.css'

type LoginFormValues = {
  email: string
  password: string
  [key: string]: string
}

// type LoginFormErrors = {
//   email?: string
//   password?: string
//   general?: string
//   [key: string]: string | undefined
// }

interface LoginFormProps {
  values: LoginFormValues
  // errors: LoginFormErrors
  isLoading: boolean
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleSubmit: (e: FormEvent) => void
  handleForgotPassword: () => void
}

const LoginForm = ({ values, isLoading, handleChange, handleSubmit, handleForgotPassword }: LoginFormProps) => {
  const handleKeyDown = (event: KeyboardEvent, handler: () => void) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handler()
    }
  }
  return (
    <form
      className={styles.form}
      onSubmit={(e: FormEvent) => {
        e.preventDefault()
        e.stopPropagation()
        handleSubmit(e)
      }}
    >
      {/*{errors.general ? <div style={{ color: 'var(--color-state-paused)', fontSize: 'var(--font-size-12)' }}>{errors.general}</div> : null}*/}

      <Input
        id="email"
        placeholder="Email"
        value={values.email}
        onChange={handleChange}
        disabled={isLoading}
        // error={errors.email}
      />

      <Input
        id="password"
        type="password"
        placeholder="Password"
        value={values.password}
        onChange={handleChange}
        disabled={isLoading}
        // error={errors.password}
      />

      <div className={styles.actions}>
        <Button
          type="button"
          variant="fill"
          size="large"
          style={{ width: '100%' }}
          onClick={(e: MouseEvent) => {
            e.preventDefault()
            e.stopPropagation()
            handleSubmit(e as unknown as FormEvent)
          }}
          onKeyDown={(e) =>
            handleKeyDown(e, () => {
              e.preventDefault()
              handleSubmit(e as unknown as FormEvent)
            })
          }
          disabled={isLoading}
        >
          {isLoading ? 'Signing In...' : 'Sign in'}
        </Button>
      </div>

      <button
        type="button"
        className={styles.linkBtn}
        onClick={handleForgotPassword}
        onKeyDown={(e) => handleKeyDown(e, handleForgotPassword)}
      >
        Forgot password?
      </button>
    </form>
  )
}

export default LoginForm
